import React from 'react';

const Configuration = () => {
  return <div />;
};
export default Configuration;
